import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface VpnStatusState {
  isOnline: boolean
}

const initialState: VpnStatusState = {
  isOnline: true,
}

const vpnStatusSlice = createSlice({
  name: 'vpnStatus',
  initialState,
  reducers: {
    setVpnOnlineStatus: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload
    },
  },
})

export const { setVpnOnlineStatus } = vpnStatusSlice.actions

export default vpnStatusSlice.reducer
